// removed by extract-text-webpack-plugin
module.exports = {"button":"_38WQb","altPrimary":"_2tvJI","primary":"_1o-qV","active":"_39lVG","large":"c0Xjo"};